import React from "react"
import { Nav } from "./styles"
export function Menu() {
	return (
		<Nav href="https://shrs.me/Pq2e8qIkuW" target="_blank" rel="noreferrer">
			<ul>
				<li>
					<img
						src="https://img.sheroes.in/img/uploads/sheroespage/logoes/1532598677ic_sheroes_launcher.png"
						alt="sheroes"
					/>
				</li>
				<li>
					<p>Join our tribe</p>
					<p>Download the #SHEROES App</p>
				</li>
			</ul>
		</Nav>
	)
}
